import { render, staticRenderFns } from "./playList.vue?vue&type=template&id=05745028&"
import script from "./playList.vue?vue&type=script&lang=js&"
export * from "./playList.vue?vue&type=script&lang=js&"
import style0 from "./playList.vue?vue&type=style&index=0&id=05745028&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports